var _defs, _polygon, _polygon2, _polygon3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.14 30.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.61 9.72 14.5 6.87 5.39 9.72 14.5 12.57 23.61 9.72"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.93 13.7 5.39 10.85 5.39 21.11 13.93 23.96 13.93 13.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.07 23.96 23.61 21.11 23.61 10.85 15.07 13.7 15.07 23.96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.99,9.77c-.37-.87-.82-1.7-1.34-2.47-.52-.77-1.12-1.5-1.78-2.16-.66-.66-1.38-1.26-2.15-1.78-.78-.53-1.61-.98-2.48-1.34-1.46-.62-3-.98-4.58-1.09v-.92l-2.91,1.64,2.91,1.64v-.9c3.08.25,5.98,1.58,8.17,3.79,2.47,2.45,3.85,5.79,3.85,9.27h1.46c0-1.95-.39-3.88-1.15-5.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.21,28.53c-7.07-.2-12.74-5.98-12.75-13.09H0c0,1.95.39,3.88,1.15,5.67,1.1,2.6,2.94,4.83,5.28,6.41,2.3,1.56,5.01,2.41,7.78,2.47v.92l2.91-1.64-2.91-1.64v.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DView);
export default __webpack_public_path__ + "static/media/3d_view.d5b7fffec73df7c9017e03f0a3c7e4cc.svg";
export { ForwardRef as ReactComponent };